import React, { useEffect, useState } from 'react';

import {
  BoxSelects,
  BtnSelectAll,
  ContainerSelectInscricoes,
  Overlay,
  SelectResponsive,
  SelectResponsiveCDD,
} from './styles';
import DrawerEstoque from '../../../modules/estoque/components/Drawer';
import { Avatar, Badge, Button, Tooltip } from 'antd';
import { useWindowSize } from '../../../hook/useWindowSize';
import { CloseOutlined, ProfileOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { cddSelect, inscSelect } from '../../../store/ducks/auth/actions';
import { clearCart } from '../../../store/ducks/estoqueCart/actions';
import mask from '../../../utils/mask';
import { storagePersist } from 'utils/storagePersist';

interface IBoxSelect {}

const BoxSelect: React.FC<IBoxSelect> = () => {
  const [activeSelectInscricoes, setActiveSelectInscricoes] = useState(false);
  const { width }: any = useWindowSize();
  const { Option } = SelectResponsive;
  const dispatch = useDispatch();
  const { user, inscricaoAtiva, cddAtivo } = useSelector((state: ApplicationState) => state.auth);
  const [iconClose, setIconClose] = useState(true);
  const [activeSelectInscricoesNome, setActiveSelectInscricoesNome] = useState([]);
  useEffect(() => {
    var resArr: any = [];

    user?.depositantes?.map((itemd) =>
      itemd.inscricoesEstaduais?.filter(function (itemP: any) {
        var i = inscricaoAtiva.find((x: any) => x === itemP.codParceiro);
        if (i >= 0) {
          resArr.push({
            nomeParceiro: itemP.nomeParceiro,
            cnpjcpf: itemP.cnpjcpf,
            inscricaoEstadual: itemP.inscricaoEstadual,
            codParceiro: itemP.codParceiro,
          });
        }
        return null;
      })
    );

    user?.inscricoesEstaduais?.filter(function (itemP: any) {
      var i = inscricaoAtiva?.find((x: any) => x === itemP.codParceiro);
      if (i >= 0) {
        resArr.push({
          nomeParceiro: itemP.nomeParceiro,
          cnpjcpf: itemP.cnpjcpf,
          inscricaoEstadual: itemP.inscricaoEstadual,
          codParceiro: itemP.codParceiro,
        });
      }
      return null;
    });

    setActiveSelectInscricoesNome(resArr);
    // eslint-disable-next-line
  }, [inscricaoAtiva, user?.inscricoesEstaduais]);
  const handleSelectDataChange = (value: any) => {
    value.length > 1 ? setIconClose(false) : setIconClose(true);
    dispatch(inscSelect(value));
    dispatch(clearCart());
    storagePersist();
  };

  const selectAll = () => {
    const ArrayIscricoesEstaduais = user?.inscricoesEstaduais?.map((item) => item.codParceiro);
    handleSelectDataChange(ArrayIscricoesEstaduais);
  };
  const clearAll = () => {
    handleSelectDataChange([]);
  };

  const handleSelectCDD = (value: any) => {
    var cddSelecionado;

    [cddSelecionado] =
      user?.centroDistribuicao?.filter(
        (centroDistribuicao) => centroDistribuicao.codCdd === value
      ) || [];

    if (cddSelecionado) {
      dispatch(cddSelect(cddSelecionado));
      dispatch(clearCart());
      storagePersist();
    }
  };

  const children = [];
  children.push(
    user?.inscricoesEstaduais?.map((inscData) =>{

      return (
      <Option
        title={inscData.nomeParceiro}
        className="optionselect"
        value={inscData.codParceiro}
        key={inscData.codParceiro}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjcpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.razaoSocial} - Código: {inscData.codParceiro}
        <hr />
      </Option>
    )})
  );

  return (
    <BoxSelects collapsed={false}>
      <Overlay
        collapsed={activeSelectInscricoes}
        onClick={() => setActiveSelectInscricoes(!activeSelectInscricoes)}
      />
      <>
        <div>
          <DrawerEstoque type={'header'} />
        </div>
        <Button
          type="link"
          href="#"
          style={{ padding: '0', marginTop: -12, marginRight: 5 }}
          onClick={() => setActiveSelectInscricoes(!activeSelectInscricoes)}
        >
          {width > 768 && (
            <Badge
              size="small"
              count={inscricaoAtiva?.length > 0 ? inscricaoAtiva.length : 0}
              style={{ backgroundColor: '#1890FF' }}
              offset={[-2, 10]}
            >
              <Avatar
                style={{ backgroundColor: 'transparent' }}
                icon={!activeSelectInscricoes ? <UnorderedListOutlined /> : <CloseOutlined />}
                shape="square"
                size={40}
              />
            </Badge>
          )}
        </Button>
        {width <= 768 && (
          <Button
            type="link"
            href="#"
            style={{ padding: '0', marginTop: -12, marginRight: '10px ' }}
            onClick={() => setActiveSelectInscricoes(!activeSelectInscricoes)}
          >
            <Badge
              size="small"
              count={inscricaoAtiva?.length > 0 ? inscricaoAtiva.length : 0}
              style={{ backgroundColor: '#1890FF' }}
              offset={[-10, 10]}
            >
              <Avatar
                style={{ backgroundColor: 'transparent' }}
                icon={!activeSelectInscricoes ? <UnorderedListOutlined /> : <CloseOutlined />}
                shape="square"
                size={40}
              />
            </Badge>
          </Button>
        )}
      </>

      <ContainerSelectInscricoes collapsed={activeSelectInscricoes}>
        <h4>Centro de distribuição:</h4>
        {user?.centroDistribuicao && (
          <SelectResponsiveCDD
            placeholder="Selecione um centro distribuição"
            onChange={handleSelectCDD}
            value={cddAtivo?.codCdd}
          >
            {user?.centroDistribuicao?.map((cdd) => (
              <Option value={cdd.codCdd} key={cdd.codCdd}>
                {cdd.nomeFantasia}
              </Option>
            ))}
          </SelectResponsiveCDD>
        )}

        {user?.inscricoesEstaduais && (
          <>
            <Tooltip
              autoAdjustOverflow={false}
              placement="rightTop"
              title={activeSelectInscricoesNome.map((item: any) => {
                return (
                  <>
                    Nome: {item.nomeParceiro}
                    <br />
                    Inscrição estadual: {item.inscricaoEstadual}
                    <hr />
                  </>
                );
              })}
            >
              <BtnSelectAll>
                <header>
                  <h4>Parceiros: </h4>
                </header>
                <section>
                  <Tooltip title="Selecionar Todos">
                    <ProfileOutlined style={{ color: '#1890FF' }} onClick={selectAll} />
                  </Tooltip>
                  <Tooltip title="Limpar Seleção">
                    <CloseOutlined style={{ color: '#1890FF' }} onClick={clearAll} />
                  </Tooltip>
                </section>
              </BtnSelectAll>

              <SelectResponsive
                showSearch
                getPopupContainer={(triggerNode: HTMLElement) =>
                  triggerNode.parentNode as HTMLElement
                }
                mode="multiple"
                placeholder={'Selecione uma unidade'}
                className="selectInscriEstadual"
                onChange={handleSelectDataChange}
                maxTagCount={1}
                defaultValue={inscricaoAtiva}
                value={inscricaoAtiva}
                filterOption={(inputValue, element) =>
                  element?.props.children
                    .toString()
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                }
                showiconclose={iconClose}
              >
                {children}
              </SelectResponsive>
            </Tooltip>
          </>
        )}
      </ContainerSelectInscricoes>
    </BoxSelects>
  );
};

export default BoxSelect;
